export const CUSTOMER_GROUP_DOCUMENT_DROP_DOWN_ITEMS = []